import { render } from "./TheEvent.vue?vue&type=template&id=51a0568a&scoped=true&ts=true&lang=html"
import script from "./TheEvent.vue?vue&type=script&lang=ts"
export * from "./TheEvent.vue?vue&type=script&lang=ts"

import "./TheEvent.vue?vue&type=style&index=0&id=51a0568a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a0568a"]])

export default __exports__